import React, {memo} from "react";
import CardProduct from "../../../../partials/card/CardProduct";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {useSelector} from "react-redux";
import {FaAngleDoubleLeft} from "react-icons/all";

const PageSearch = () => {
    const {listResult} = useSelector(state => state.search);
    return (
        <div className={'base-box-page-more-products'}>
            <div className={'box-page-more-products'}>
                <div className={'box-header-page-more-products'}>
                    <FaAngleDoubleLeft className={'icon-header-page-more-products'}/>
                    <h6 className={'txt-title-header-page-more-products'}>
                        <span> نتیجه جستوجو </span>
                        <span style={{fontSize: 12}}>({listResult.length} مورد پیدا شد)</span>
                    </h6>
                </div>
                <div className={'box-list-items-page-more-products'}>
                    <Row>
                        {listResult.length > 0 && listResult.map((item, index) =>
                            <Col xs={6} sm={4} md={3} lg={2} key={index}>
                                <CardProduct product={item}/>
                            </Col>
                        )}
                    </Row>
                </div>
            </div>
        </div>
    );
};
export default memo(PageSearch);
